import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from '@shared/components/multi-select/multi-select.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonIconModule } from '@impairedShared/button-icon/button-icon.module';
import { ImpairedPaginationModule } from '@impairedShared/impaired-pagination/impaired-pagination.module';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { RoutingModule } from './routing.module';
import { MainComponent } from './components/main/main.component';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RoutingModule,
    NgLetModule,
    ButtonIconModule,
    TranslateModule,
    MultiSelectModule,
    ImpairedPaginationModule,
    ImpairedIconModule
  ]
})
export class TableModule {}
